import { render, staticRenderFns } from "./EditarVenta.vue?vue&type=template&id=7566bdf9&"
import script from "./EditarVenta.vue?vue&type=script&lang=js&"
export * from "./EditarVenta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports